import { isStatus, Status } from "@shared/types/status.types";
import { DATA_DISPLAY_TYPES, DataDisplayType } from "../data-display-type";
import { Duration, isDate } from "date-fns";
import { isDuration } from "@shared/types/duration.type";
import { isTranslationInfo, TranslationInfo } from "@shared/types/translation-info";
import { DatePeriod, isDatePeriod, isTimePeriod, TimePeriod } from "@shared/types/period.type";
import { isBoolean } from "es-toolkit";

export type TableData =
  | { type: typeof DATA_DISPLAY_TYPES.string; value: string; }
  | { type: typeof DATA_DISPLAY_TYPES.boolean; value: boolean; }
  | { type: typeof DATA_DISPLAY_TYPES.img; src: string; }
  | { type: typeof DATA_DISPLAY_TYPES.status; status: Status; }
  | { type: typeof DATA_DISPLAY_TYPES.date; date: Date; }
  | { type: typeof DATA_DISPLAY_TYPES.edit; }
  | { type: typeof DATA_DISPLAY_TYPES.duration; duration: Duration; }
  | { type: typeof DATA_DISPLAY_TYPES.datePeriod; datePeriod: DatePeriod; }
  | { type: typeof DATA_DISPLAY_TYPES.timePeriod; timePeriod: TimePeriod; }
  | { type: typeof DATA_DISPLAY_TYPES.localizedString; translationInfo: TranslationInfo; };
export function parseToTableData (dataDisplayType: DataDisplayType, value: unknown): TableData | undefined {
  switch (dataDisplayType) {
    case DATA_DISPLAY_TYPES.string: {
      if (typeof value === "string") {
        return {
          type: DATA_DISPLAY_TYPES.string,
          value
        } satisfies TableData;
      }

      return undefined;
    }

    case DATA_DISPLAY_TYPES[ "boolean" ]: {
      if (isBoolean(value)) {
        return {
          type: DATA_DISPLAY_TYPES[ "boolean" ],
          value
        };
      }

      return undefined;
    }

    case DATA_DISPLAY_TYPES.img: {
      if (typeof value === "string") {
        return {
          type: DATA_DISPLAY_TYPES.img,
          src: value
        } satisfies TableData;
      }

      return undefined;
    }

    case DATA_DISPLAY_TYPES.date: {
      if (isDate(value)) {
        return {
          type: DATA_DISPLAY_TYPES.date,
          date: value
        } satisfies TableData;
      }

      return undefined;
    }

    case DATA_DISPLAY_TYPES.status: {
      if (isStatus(value)) {
        return {
          type: DATA_DISPLAY_TYPES.status,
          status: value
        } satisfies TableData;
      }

      return undefined;
    }

    case DATA_DISPLAY_TYPES.edit: {
      return {
        type: DATA_DISPLAY_TYPES.edit
      } satisfies TableData;
    }

    case DATA_DISPLAY_TYPES.duration: {
      if (isDuration(value)) {
        return {
          type: DATA_DISPLAY_TYPES.duration,
          duration: value
        };
      }

      return undefined;
    }

    case DATA_DISPLAY_TYPES.localizedString: {
      if (isTranslationInfo(value)) {
        return {
          type: DATA_DISPLAY_TYPES.localizedString,
          translationInfo: value
        };
      }

      return undefined;
    }

    case DATA_DISPLAY_TYPES.datePeriod: {
      if (isDatePeriod(value)) {
        return {
          type: DATA_DISPLAY_TYPES.datePeriod,
          datePeriod: value
        };
      }

      return undefined;
    }

    case DATA_DISPLAY_TYPES.timePeriod: {
      if (isTimePeriod(value)) {
        return {
          type: DATA_DISPLAY_TYPES.timePeriod,
          timePeriod: value
        };
      }

      return undefined;
    }
  }
}
